"use strict";

const FacilityInspectionSubmission = function () {
  const stringKey = "submission";
  const tabHeader = "Submission";
  let actionItemConstants;
  let $page;

  var loadListeners = function (data) {
    $page = $(`#assessment-modal #${stringKey}`);

    $page.on("click", "[name='preview']", previewButtonClick);
    $page.on("2N:FormInput", "[name='isSiteRepPresent']", onIsSiteRepPresentChange);
    $page.on("2N:FormInput", "[name='start-time'], [name='end-time']", onStartOrEndDateChange);
    $page.on("2N:FormInput", "[name='materialsDistributed']", onMaterialsDistributedChange);
    $page.on("2N:FormInput", "[name^='recommendedActions[']", onRecommendedActionChange);
  };

  var unloadListeners = function () {
    $page.off("click", "[name='preview']", previewButtonClick);
    $page.off("2N:FormInput", "[name='isSiteRepPresent']", onIsSiteRepPresentChange);
    $page.off("2N:FormInput", "[name='start-time'], [name='end-time']", onStartOrEndDateChange);
    $page.off("2N:FormInput", "[name='materialsDistributed']", onMaterialsDistributedChange);
    $page.off("2N:FormInput", "[name^='recommendedActions[']", onRecommendedActionChange);
  };

  var getProps = function (data) {
    actionItemConstants = ToolSettings.getSetting(
      "indcom",
      "facility-inspection-constants",
    ).actionItemConstants;
    return {
      followUpInspectionTypeOptions: FormSettings.getDropdownOptions("follow-up-inspection-type"),
      actionItemsByCategory: getActionItemsByCategory(),
      materialTypeOptions: ToolSettings.getDomainOptions("material_type"),
      escalationActionOptions: BaseEnforcementAction().escalationActionOptions,
      enforcementEntityLabel: "facility",
    };
  };

  var getStringKey = function () {
    return stringKey;
  };

  var getTabHeader = function () {
    return tabHeader;
  };

  var onIsSiteRepPresentChange = function (e, isSiteRepPresent) {
    const $fieldsContainer = $("#is-site-rep-present-field-container-js");
    $fieldsContainer.toggle(isSiteRepPresent);
    // Field data is conditionally nulled in the API
  };

  var previewButtonClick = async function () {
    return await InspectionPreview.preview(function () {
      const previewData = FacilityInspectionController.getDataToUpload();
      previewData.facilityId = FacilityInspectionController.getAllData().facility.id;
      return previewData;
    }, ApiCalls.downloadFacilityInspectionPreview);
  };

  var onStartOrEndDateChange = function () {
    const startTime = $("[name='start-time']").val();
    const endTime = $("[name='end-time']").val();
    const $total = $("[name='total-inspection-time']");

    setDateRanges();
    if (startTime === "" || endTime === "") {
      $total.val("");
    } else {
      const minutes = Math.floor(
        (new Date(endTime) - new Date(startTime)) / (1000 * 60),
      ).toLocaleString("en-us");
      $total.val(minutes);
    }
  };

  var setDateRanges = function () {
    const startTime = $("[name='start-time']").val();
    const endTime = $("[name='end-time']").val();

    if (startTime) {
      DateTimePicker.setDatePickerRange($("#assessment-modal"), "end-time", false, startTime);
    }
    if (endTime) {
      DateTimePicker.setDatePickerRange($("#assessment-modal"), "start-time", true, endTime);
    }
  };

  var onMaterialsDistributedChange = function (e, materialsDistributed) {
    const $materialTypeField = $(".material-type");
    $materialTypeField.toggle(materialsDistributed);
  };

  var getActionItemsCheckboxValues = function () {
    const $actionItems = $('[name="actionItems"]:checked');
    return $actionItems.map((i, item) => item.value).get();
  };

  var getActionItemsByCategory = function () {
    const grouped = new Map();
    actionItemConstants.forEach(function (item) {
      if (!grouped.has(item.category)) {
        grouped.set(item.category, []);
      }
      const category = grouped.get(item.category);
      category.push({
        name: item.description,
        value: item.id,
      });
    });
    return grouped;
  };

  var renderSummary = function (data) {
    const observationsData = FacilityInspectionSummary.getObservationsData();
    $page
      .find("#js-facility-inspection-submission-summary")
      .html(FacilityInspectionSummary.getSummaryHtml(data, observationsData));

    toggleFollowUp(observationsData.nonCompliantFindingsCount > 0);
  };

  var toggleFollowUp = function (showFollowUp) {
    $page.find("#js-facility-inspection-follow-up").toggle(showFollowUp);
    FacilityInspectionController.setFormData(["followUpInspection"], showFollowUp);
  };

  var tabShownCallback = function () {
    setDateRanges();
  };

  var onRecommendedActionChange = function () {
    const recommendedActions = {};
    $("[name^='recommendedActions[']").each(function () {
      const $select = $(this);
      const $row = $select.closest("[data-enforcement-id]");
      const enforcementId = $row.data("enforcement-id");
      recommendedActions[enforcementId] = $select.val();
    });

    FacilityInspectionController.setFormData(["recommendedActions"], recommendedActions);
  };

  return {
    loadListeners,
    unloadListeners,
    onStartOrEndDateChange,
    getStringKey,
    getTabHeader,
    getProps,
    getActionItemsCheckboxValues,
    renderSummary,
    tabShownCallback,
  };
};

module.exports = FacilityInspectionSubmission();

const ApiCalls = require("../../apiCalls");
const FacilityInspectionController = require("./facilityInspectionController");
const InspectionPreview = require("../../general/inspectionPreview");
const FormSettings = require("../../settings/formSettings");
const ToolSettings = require("../../settings/toolSettings");
const FacilityInspectionSummary = require("./facilityInspectionSummary");
const DateTimePicker = require("../../general/dateTimePicker");
const BaseEnforcementAction = require("../../enforcement/baseEnforcementAction");
